import {
  Dashboard,
  MyFiles,
  Notification,
  Profile,
} from "../features/non-lawyer";
import CreateCase from "../features/non-lawyer/createcase";
import EditCases from "../features/non-lawyer/edit-cases";
import FileAProcess from "../features/non-lawyer/file-a-process";
import FileDefence from "../features/non-lawyer/file-defence";
import Plaintiff from "../features/non-lawyer/plaintiff";
import ProceedPayment from "../features/non-lawyer/proceed-payment";
import SearchResult from "../features/non-lawyer/search-result";
import ViewCases from "../features/non-lawyer/view-cases";
import ViewFolder from "../features/non-lawyer/view-folder";

export const NonLawyerRoutes = [
  {
    id: "1",
    title: "Dashboard",
    component: Dashboard,
    path: "non-lawyer",
  },
  {
    id: "2",
    title: "My Files",
    component: MyFiles,
    path: "non-lawyer/my-files",
  },
  {
    id: "3",
    title: "Notification",
    component: Notification,
    path: "non-lawyer/notification",
  },
  {
    id: "4",
    title: "Profile",
    component: Profile,
    path: "non-lawyer/profile",
  },
  {
    id: "5",
    title: "search",
    component: SearchResult,
    path: "non-lawyer/search-result",
  },
  {
    id: "6",
    title: "folder",
    component: ViewFolder,
    path: "non-lawyer/view-folder",
  },
  {
    id: "7",
    title: "ProceedPayment",
    component: ProceedPayment,
    path: "non-lawyer/proceed",
  },
  {
    id: "8",
    title: "ViewCases",
    component: ViewCases,
    path: "non-lawyer/view-case",
  },
  {
    id: "9",
    title: "EditCases",
    component: EditCases,
    path: "non-lawyer/edit-case",
  },
  {
    id: "9",
    title: "filedefence",
    component: FileDefence,
    path: "non-lawyer/file-defence-process/case-folder",
  },
  {
    id: "9",
    title: "filedefence",
    component: Plaintiff,
    path: "non-lawyer/join-as-plaintiff",
  },
  {
    id: "9",
    title: "filedefence",
    component: Plaintiff,
    path: "non-lawyer/join-as-defendant",
  },
  {
    id: "9",
    title: "createcase",
    component: CreateCase,
    path: "non-lawyer/create-case",
  },
  {
    id: "10",
    title: "fileprocess",
    component: FileAProcess,
    path: "non-lawyer/file-a-process",
  },
];
